/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonIdAddressesQueryResponse,
  GetApiV1PersonIdAddressesPathParams,
  GetApiV1PersonIdAddresses401,
  GetApiV1PersonIdAddresses404,
  GetApiV1PersonIdAddresses500,
} from "../../types/personRegisterController/GetApiV1PersonIdAddresses.ts";

function getGetApiV1PersonIdAddressesUrl(
  id: GetApiV1PersonIdAddressesPathParams["id"],
) {
  const res = { method: "GET", url: `/api/v1/person/${id}/addresses` as const };
  return res;
}

/**
 * @description Retorna todos os endereços vinculados à pessoa. **(Requer Authorization para autenticação)**
 * @summary Listar endereços da pessoa (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/addresses}
 */
export async function getApiV1PersonIdAddresses(
  id: GetApiV1PersonIdAddressesPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonIdAddressesQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonIdAddresses401
      | GetApiV1PersonIdAddresses404
      | GetApiV1PersonIdAddresses500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonIdAddressesUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
